import React from "react";
const ChevronDown = ({ color, style }) => {
    return (React.createElement("svg", { className: style, width: "10", height: "7", viewBox: "0 0 10 7", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M4.54699 6.16427L8.7544 1.95692C9.14493 1.5664 9.14493 0.933229 8.75441 0.542702C8.36388 0.152179 7.73072 0.152176 7.3402 0.542695L4.547 3.33585L1.75413 0.542835C1.36361 0.152295 0.730434 0.152286 0.339904 0.542816C-0.050614 0.933333 -0.0506201 1.56649 0.33989 1.95701L4.54699 6.16427Z", fill: color || "#798395" })));
};
export default ChevronDown;
